import React, { useMemo, useState } from "react";
import styles from "../../assets/styles/Marketers/Marketers.module.scss";
import {
  AppPage,
  MimaButton,
  MimaDropdownFilter,
  MimaPaginatedDropdown,
  MimaText,
} from "../../components";

import { amountFormatter } from "../../utils/utils";
import { Formik } from "formik";

import {
  BusinessPartnerContainer,
  MarketerTableContainer,
  ViewTodoContainer,
} from "../../containers";

import { observer } from "mobx-react";
import { AnimatePresence } from "framer-motion";
import { businessStore } from "../../stores";

const MarketersAnalysis = ({
  data,
  marketerTable,
  businessPartnerTable,
  goToBusinessPartnerTable,
  goToMarketerTable,
  marketerAnalysis,
  validationSchema,
  showFilter,
  setShowFilter,
  onSubmit,
  filterByData,
  selectedFilterParam,
  setSelectedFilterParam,
  filterTitle,
  closeFilter,
  loading,
  closeModal,
  todoModal,
  setTodoModal,
  filterParams,
}) => {
  const [selectedParamIndex, setSelectedParamIndex] = useState(0);
  const [marketer, setMarketer] = useState("");
  const [businessPartner, setBusinessPartner] = useState("");
  const [item, setItem] = useState({});
  const [tradingName, setTradingName] = useState({});

  const referralAnalysis = useMemo(
    () => [
      {
        name: "Referrals",
        details: [
          {
            title: "Total Referrals",
            amount: marketerAnalysis?.totalReferral || 0,
          },
          {
            title: "Total Subscribed Referrals",
            amount: marketerAnalysis?.subscribedReferral || 0,
          },
          {
            title: "Total Referrals not Subscribed",
            amount: marketerAnalysis?.notSubscribedReferral || 0,
          },
        ],
      },
      {
        name: "Paid Commission",
        details: [
          {
            title: "Lite Plan Referral",
            amount: amountFormatter("NGN").format(
              marketerAnalysis?.paidCommission?.LiteCommission || 0
            ),
          },
          {
            title: "Basic Plan Referral",
            amount: amountFormatter("NGN").format(
              marketerAnalysis?.paidCommission?.basicCommission || 0
            ),
          },
          {
            title: "Premium Plan Referral",
            amount: amountFormatter("NGN").format(
              marketerAnalysis?.paidCommission?.premiumCommission || 0
            ),
          },
        ],
      },
      {
        name: "Pending Commission",
        details: [
          {
            title: "Lite Plan Referral",
            amount: amountFormatter("NGN").format(
              marketerAnalysis?.unpaidCommission?.LiteCommission || 0
            ),
          },
          {
            title: "Basic Plan Referral",
            amount: amountFormatter("NGN").format(
              marketerAnalysis?.unpaidCommission?.basicCommission || 0
            ),
          },
          {
            title: "Premium Plan Referral",
            amount: amountFormatter("NGN").format(
              marketerAnalysis?.unpaidCommission?.premiumCommission || 0
            ),
          },
        ],
      },
    ],

    [marketerAnalysis]
  );

  const marketerIdArray = data?.data?.commissions?.map((x) => ({
    key: x?.marketer?._id,
    value: `${x?.marketer?.firstname} ${x?.marketer?.lastname}`,
  }));
  const businessPartnerIdArray = data?.data?.commissions?.map((x) => ({
    key: x?.businessPartner?._id,
    value: x?.businessPartner?.tradingName,
  }));

  const goToFilterSelection = (item, i) => {
    setSelectedFilterParam(item);
    setSelectedParamIndex(i);
  };

  return (
    <AppPage pageTitle="Marketers Analysis">
      <div>
        <div className={styles.filter}>
          <MimaButton
            title={showFilter ? "Close Filter" : "Filter"}
            onClick={() => {
              setShowFilter(!showFilter);
            }}
            mt={2}
          />
        </div>

        {showFilter && (
          <div className={styles.filter__beside}>
            <Formik
              initialValues={{
                selectedFilter: "Type",
                type: "",
                marketer: "",
                businessPartner: "",
                filterTitle: "",
              }}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                values,
                errors,
                touched,
              }) => (
                <>
                  <div className={styles.filter__by}>
                    <MimaText
                      variant="small"
                      color="var(--color-primary)"
                      style={{ padding: "1rem" }}
                    >
                      Filter by
                    </MimaText>

                    {filterByData.map((x, i) => (
                      <li
                        key={i}
                        className={`${styles.filter__by__list} ${selectedParamIndex === i && styles.filter__by__list__active}`}
                        onClick={() => {
                          goToFilterSelection(x, i);
                          setFieldValue("selectedFilter", x.value);
                        }}
                      >
                        {x.value}
                      </li>
                    ))}
                  </div>

                  <div className={styles.filter__action}>
                    {selectedFilterParam.value === "Type" && (
                      <>
                        <MimaDropdownFilter
                          labelTitle="Filter by Type"
                          placeholder="Select type"
                          width={26}
                          name="type"
                          value={values.type}
                          data={[
                            { value: "Marketer", key: "marketer" },
                            {
                              value: "Business Partner",
                              key: "businessPartner",
                            },
                          ]}
                          onChange={(data) => {
                            setFieldValue("type", data.key);
                            setFieldValue("filterTitle", data.value);
                          }}
                          error={errors.type}
                          touched={touched.type}
                        />
                      </>
                    )}

                    {selectedFilterParam.value === "Business-Partner" && (
                      <>
                        <MimaDropdownFilter
                          labelTitle="Filter by Business Partner"
                          placeholder="Select Partner"
                          width={26}
                          name="businessPartner"
                          value={values.businessPartner}
                          data={businessPartnerIdArray}
                          onChange={(data) => {
                            setFieldValue("businessPartner", data.key);
                            setFieldValue("filterTitle", data.value);
                            setBusinessPartner(data.key);
                          }}
                          error={errors.businessPartner}
                          touched={touched.businessPartner}
                        />
                      </>
                    )}

                    {selectedFilterParam.value === "Marketer" && (
                      <>
                        {/* <MimaPaginatedDropdown
                          mb={2}
                          mt={2}
                          labelTitle="Marketer"
                          placeholder="Select Marketer"
                          name="marketer"
                          value={values.marketer}
                          id="marketer"
                          optionLabel="marketerName"
                          touched={touched.marketer}
                          error={errors.marketer}
                          url={`/marketers/admin/commission?type=marketer`}
                          queryKey={[businessStore.bId, "marketer"]}
                          getPageValue={(page) => page?.data?.commissions || []}
                          getPageTotalCount={(lastPage) =>
                            lastPage?.data?.totalCounts || 0
                          }
                          onChange={(data) => {
                            console.log("data", data);
                            setFieldValue("marketer", data._id);
                            setFieldValue(
                              "marketerName",
                              data?.marketer?.firstname
                            );
                            setMarketer(data._id);
                          }}
                        /> */}

                        <MimaDropdownFilter
                          labelTitle="Filter by Marketer"
                          placeholder="Select Marketer"
                          width={26}
                          name="marketer"
                          value={values.marketer}
                          data={marketerIdArray}
                          onChange={(data) => {
                            setFieldValue("marketer", data.key);
                            setFieldValue("filterTitle", data.value);
                            setMarketer(data.key);
                          }}
                          error={errors.marketer}
                          touched={touched.marketer}
                        />
                      </>
                    )}

                    <div className={styles.filter__action__btns}>
                      <MimaButton
                        title="Cancel"
                        variant="filter"
                        buttonColor="var(--color-error)"
                        width={10}
                        onClick={closeFilter}
                      />
                      <MimaButton
                        title="Apply Filter"
                        variant="filter"
                        buttonColor="var(--color-primary)"
                        width={13}
                        onClick={handleSubmit}
                      />
                    </div>
                  </div>
                </>
              )}
            </Formik>
          </div>
        )}
        {filterTitle &&
        (filterTitle === "Marketer" || filterTitle === "Business Partner") ? (
          <MimaText variant="subtitleBold" align="center" mb={4}>
            {`You are viewing Analysis for ${filterTitle}s`}
          </MimaText>
        ) : filterTitle &&
          (filterTitle !== "Business Partner" || filterTitle !== "Marketer") ? (
          <MimaText variant="subtitleBold" align="center" mb={4}>
            {`You are viewing Analysis for ${filterTitle}`}
          </MimaText>
        ) : (
          <MimaText variant="subtitleBold" align="center" mb={4}>
            You are viewing Marketers/Business Partners Analysis
          </MimaText>
        )}
      </div>

      <div className={styles.insights}>
        {referralAnalysis.map((item, i) => (
          <div key={i}>
            <MimaText variant="bodyBold" mb={1}>
              {item.name}
            </MimaText>
            <div className={styles.insights__group}>
              {item.details.map((x, index) => (
                <div key={index} className={styles.insights__group__item}>
                  <MimaText variant="small" mb={0.5}>
                    {x.title}
                  </MimaText>

                  <MimaText variant="bodyBold">{x.amount}</MimaText>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.main_nav}>
        <div
          className={
            marketerTable ? styles.main_nav_item_active : styles.main_nav_item
          }
          onClick={goToMarketerTable}
        >
          Marketer Table
        </div>
        <div
          className={
            businessPartnerTable
              ? styles.main_nav_item_active
              : styles.main_nav_item
          }
          onClick={goToBusinessPartnerTable}
        >
          Business Partner Table
        </div>
      </div>
      {marketerTable && (
        <MarketerTableContainer
          marketer={marketer}
          setItem={setItem}
          setTradingName={setTradingName}
          setTodoModal={setTodoModal}
          filterParams={filterParams}
        />
      )}
      {businessPartnerTable && (
        <BusinessPartnerContainer
          businessPartner={businessPartner}
          setItem={setItem}
          setTradingName={setTradingName}
          setTodoModal={setTodoModal}
          filterParams={filterParams}
        />
      )}

      {todoModal && (
        <div className="modal">
          <AnimatePresence>
            {todoModal && (
              <ViewTodoContainer
                closeModal={closeModal}
                item={item}
                tradingName={tradingName}
              />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};
export default observer(MarketersAnalysis);
